import React from 'react';
import { FadeIn } from './FadeIn';
export function DiagnosisSection() {
  return <section className="py-24 px-6 bg-navy-dark" data-id="element-38">
      <div className="max-w-4xl mx-auto" data-id="element-39">
        <FadeIn data-id="element-40">
          <h2 className="text-3xl md:text-5xl font-serif mb-10 text-center md:text-left" data-id="element-41">
            El problema no es la carga. <br className="hidden md:block" data-id="element-42" />
            <span className="text-gold" data-id="element-43">
              Es cómo está construido tu negocio.
            </span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-44">
          <p className="text-lg md:text-xl text-gray-light font-sans mb-12" data-id="element-45">
            Tu negocio creció. Pero creció sin una estructura operativa clara
            que lo sostenga — y sin la tecnología correcta para multiplicar lo
            que funciona. Eso no es un problema de esfuerzo. Es un problema de
            diseño.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-46">
          <div className="bg-navy-dark border border-gold p-8 md:p-12 rounded-xl text-center" data-id="element-47">
            <p className="text-2xl md:text-4xl font-serif text-gold leading-tight" data-id="element-48">
              No es un problema de trabajar más.{' '}
              <br className="hidden md:block" data-id="element-49" />
              Es un problema de diseño.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}